import { observer } from 'mobx-react';
import React from 'react';
import {
  RolesSelect,
  TimeZoneSelect,
  X1LanguageSelect,
  X2AgeCategorySelect,
  X3LevelSelect
} from '../../../lib/components';
import { UserEditFormStore } from './UserEditFormStore';
import { dateFormat } from '../../../lib/helpers';

@observer
export class UserEditForm extends React.Component<{ store: UserEditFormStore }> {
  render() {
    const store = this.props.store;
    const student = store.student;
    const teacher = store.teacher;
    const level = store.student.selectLevel;

    const isNew = store.id == 0;
    const isEdit = store.id > 0;

    return (<>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              User
            </div>
            <div className="card-body">
              <div className="row">
                {isEdit &&
                  <div className="form-group col-sm-6 col-md-4">
                    <label>Identifier</label>
                    <div className="text-box">{store.id}</div>
                  </div>
                }
                <div className="col-sm-6 col-md-4">
                  <div className={store.firstName.formGroupClassName}>
                    <label>First name</label>
                    <input className="form-control" type="text"
                      value={store.firstName.value}
                      onChange={store.firstName.onChangeHandler}
                      onBlur={store.firstName.markTouched} />
                    <div className="invalid-text">Enter first name</div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className={store.lastName.formGroupClassName}>
                    <label>Last name</label>
                    <input className="form-control" type="text"
                      value={store.lastName.value}
                      onChange={store.lastName.onChangeHandler}
                      onBlur={store.lastName.markTouched} />
                    <div className="invalid-text">Enter last name</div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className={store.email.formGroupClassName}>
                    <label>Email</label>
                    <input className="form-control" type="text"
                      value={store.email.value}
                      onChange={store.email.onChangeHandler}
                      onBlur={store.email.markTouched} />
                    <div className="invalid-text">Email required</div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className={store.mobile.formGroupClassName}>
                    <label>Mobile</label>
                    <input className="form-control" type="text"
                      value={store.mobile.value}
                      onChange={store.mobile.onChangeHandler}
                      onBlur={store.mobile.markTouched} />
                    <div className="invalid-text">Mobile required</div>
                  </div>
                </div>

                <div className="w-100" />

                <div className="col-sm-6 col-md-4">
                  <div className={store.username.formGroupClassName}>
                    <label>Username</label>
                    <input className="form-control" type="text"
                      value={store.username.value}
                      onChange={store.username.onChangeHandler}
                      onBlur={store.username.markTouched} />
                    <div className="invalid-text">Username required</div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className={store.password.formGroupClassName}>
                    <label>Password</label>
                    <input className="form-control" type="text"
                      value={store.password.value}
                      onChange={store.password.onChangeHandler}
                      onBlur={store.password.markTouched} />
                    <div className="invalid-text">Password required</div>
                  </div>
                </div>

                <div className="w-100" />

                <div className="col-sm-6 col-md-4">
                  <div className={store.timeZone.formGroupClassName}>
                    <label>Time zone</label>
                    <TimeZoneSelect options={store.timeZones}
                      value={store.timeZone.value}
                      onChange={store.timeZone.setValue}
                      onBlur={store.timeZone.markTouched} />
                    <div className="invalid-text">Select UTC TimeZone</div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className="form-group">
                    <label>Roles:</label>
                    <RolesSelect value={store.roles.value}
                      onChange={store.roles.setValue} />
                  </div>
                </div>

                <div className="w-100" />

                {isEdit &&
                  <>
                    <div className="form-group col-sm-6 col-md-4">
                      <label>Status</label>
                      <div className="text-box">{store.status}</div>
                    </div>

                    <div className="form-group col-sm-6 col-md-4">
                      <label>Created on</label>
                      <div className="text-box">{dateFormat(store.CreationDateTime, 'wymdhms', true)}</div>
                    </div>
                  </>
                }

              </div>

              {store.isStudent &&
                <div className="row">
                  <div className="col-sm-6 col-md-4">
                    <div className={level.language.formGroupClassName}>
                      <label>Student/Language</label>
                      <X1LanguageSelect options={level.languageOptions}
                        value={level.language.value}
                        onChange={level.language.setValue}
                        onBlur={level.language.markTouched} />
                      <div className="invalid-text">Enter language</div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <div className={level.ageCategory.formGroupClassName}>
                      <label>Student/Age category</label>
                      <X2AgeCategorySelect options={level.ageCategoryOptions}
                        value={level.ageCategory.value}
                        onChange={level.ageCategory.setValue}
                        onBlur={level.ageCategory.markTouched} />
                      <div className="invalid-text">Enter age category</div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-4">
                    <div className={level.level.formGroupClassName}>
                      <label>Student/Level</label>
                      <X3LevelSelect options={level.levelOptions}
                        value={level.level.value}
                        onChange={level.level.setValue}
                        onBlur={level.level.markTouched} />
                      <div className="invalid-text">Enter level</div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-4">
                    <div className={student.balance.formGroupClassName}>
                      <label>Student/Balance</label>
                      <input className="form-control" type="text"
                        value={student.balance.value}
                        onChange={student.balance.onChangeHandler}
                        onBlur={student.balance.markTouched} />
                      <div className="invalid-text">Enter balance (positive integer)</div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <div className={student.alfaStudentId.formGroupClassName}>
                      <label>ALFA CRM STUDENT ID</label>
                      <input className="form-control" type="text"
                        value={student.alfaStudentId.value}
                        onChange={student.alfaStudentId.onChangeHandler}
                        onBlur={student.alfaStudentId.markTouched} />
                      <div className="invalid-text">Enter ALFA CRM ID (positive integer)</div>
                    </div>
                  </div>
                </div>
              }

              {store.isTeacher &&
                <div className="row">
                  <div className="col-sm-6 col-md-4">
                    <div className={teacher.description.formGroupClassName}>
                      <label>Teacher/description</label>
                      <input className="form-control" type="text"
                        value={teacher.description.value}
                        onChange={teacher.description.onChangeHandler}
                        onBlur={teacher.description.markTouched} />
                      <div className="invalid-text">Enter description</div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <div className={teacher.alfaTeacherId.formGroupClassName}>
                      <label>ALFA CRM TEACHER ID</label>
                      <input className="form-control" type="text"
                        value={teacher.alfaTeacherId.value}
                        onChange={teacher.alfaTeacherId.onChangeHandler}
                        onBlur={teacher.alfaTeacherId.markTouched} />
                      <div className="invalid-text">Enter ALFA CRM ID (positive integer)</div>
                    </div>
                  </div>
                </div>
              }

            </div>
          </div>
        </div>
      </div>
    </>);
  }
}
